export const tableData = [{
    userID:1,
    userNick:"昵称",
    title:"标题"
},{
    userID:1,
    userNick:"昵称",
    title:"标题"
},{
    userID:1,
    userNick:"昵称",
    title:"标题"
},{
    userID:1,
    userNick:"昵称",
    title:"标题"
},{
    userID:1,
    userNick:"昵称",
    title:"标题"
}];